(function () {
    'use strict';
    $(document).ready(function () {
        console.log('subpage.js');

        // SOCIAL SHARING
        var $share = $('#share');
        $share.css('opacity', 1);
        $share.jsSocials({
            showLabel: false,
            showCount: false,
            shareIn: "popup",
            text: document.title,
            url: window.location.href,
            shares: [
                {
                    share: "facebook",
                    logo: `${$share.attr('data-templateURL')}/dist/images/facebook.svg`,
                    inlineSvg: true,
                },
                {
                    share: "twitter",
                    logo: `${$share.attr('data-templateURL')}/dist/images/twitter.svg`,
                    inlineSvg: true,
                    via: "pgnig",
                },
                {
                    share: "linkedin",
                    logo: `${$share.attr('data-templateURL')}/dist/images/linkedin.svg`,
                    inlineSvg: true,
                }
            ]
        });

        $('.swiper-quotations').each(function (index) {
            var quotationsSwiper = new Swiper($(this)[0],{
                navigation: {
                    nextEl: '#' + $(this)[0].id + ' .swiper-button-next',
                    prevEl: '#' + $(this)[0].id + ' .swiper-button-prev',
                },
                autoplay: {
                    delay: 5000,
                },
                disableOnInteraction: true,
                loop: true,
                autoHeight: true,
            });
        });

        $('.swiper-logo').each(function (index) {
            var logoSwiper = new Swiper($(this)[0],{
                navigation: {
                    prevEl: $(this).parent().siblings('.swiper-button-prev'),
                    nextEl: $(this).parent().siblings('.swiper-button-next'),
                },
                loop: $(this).data('loop'),
                slidesPerView: ($(this).data('count') <= 5) ? $(this).data('count') : 6,
                grabCursor: true,
                autoplay: {
                    delay: 5000,
                },
                breakpoints: {
                    1000: {
                        slidesPerView: ($(this).data('count') < 4) ? $(this).data('count') : 4,
                        spaceBetween: 40
                    },
                    640: {
                        slidesPerView: ($(this).data('count') < 3) ? $(this).data('count') : 3,
                        spaceBetween: 40
                    },
                    500: {
                        slidesPerView: ($(this).data('count') < 2) ? $(this).data('count') : 2,
                        spaceBetween: 20
                    },
                    375: {
                        slidesPerView: ($(this).data('count') == 1) ? $(this).data('count') : 1,
                        spaceBetween: 20
                    },
                }
            });
        });

        //Calendar
        $('.save-in-outlook').click(function(e){

            var date = moment($(this).data('date'),'DD/MM/YYYY');
            var cal = ics();
            var beginDate = date.format('YYYY/MM/DD');
            var endDate = date.add(1, 'days').format('YYYY/MM/DD');
            cal.addEvent(
                $(this).data('name'),
                $(this).data('description'),
                'Warszawa',
                beginDate,
                endDate
            );
            cal.download("calevent");

            e.preventDefault();
            return false;
        });

        //tools show/hide
        $('#tools-toggle').click(function () {
            $('.tools-list').animate({
                height: 'toggle'
            });
            $(this).toggleClass('opened');
        });

        // accordion scroll animation
        $('.subpage .accordion.scroll-animation .collapse, .subpage .accordion .collapse').on('shown.bs.collapse', function (e) {
            updateTableSize();
            var positionTop = $(this).parent().offset().top; // - $('header').height();
            $('html, body').animate({
                scrollTop: positionTop
            }, 500);
            $(window).resize();
        });

        // responsive image enlarging
        $('.popup-trigger').click(function (e) {
            $(this).parent().find('.popup-image-container').fadeIn();
            e.preventDefault();
            return false;
        });

        $('.popup-image-container').click(function () {
            $(this).fadeOut();
        });

        //Tooltipster

        // default tooltips
        $('.default-tooltipster').tooltipster({
            maxWidth: 290,
            contentAsHTML: true,
            interactive: true,
            functionPosition: function (instance, helper, position) {
                position.coord.left = helper.geo.origin.offset.left - 20;
                return position;
            },
        });

        function updateTableSize() {
            $('.table-container').each(function () {
                if ($(this).parent().hasClass('panel-body')) return;
                var containerWidth = $(this).width();
                var tableWidth = $('table', this).width();

                if (tableWidth > containerWidth) {
                    $(this).addClass('scrollable');
                    $(this).mCustomScrollbar({
                        axis: "x",
                        mouseWheel: {
                            enable: true
                        }
                    });
                } else {
                    $(this).removeClass('scrollable');
                    $(this).mCustomScrollbar('destroy');
                }
            });
        }

    });
}(jQuery));


